import { useState } from 'react';
import useSendErrorContext from '../useSendErrorContext';
const useSendErrorsContext = (sendErrorCallback)=>{
    const sendErrorContext = useSendErrorContext(sendErrorCallback);
    const [isSending, setIsSending] = useState(false);
    const sendErrors = async (fe, be, errors)=>{
        setIsSending(true);
        try {
            await Promise.all(errors.map((error)=>sendErrorContext(fe, be, error, error.timestamp)));
        } finally{
            setIsSending(false);
        }
    };
    return {
        sendErrors,
        isSending
    };
};
export default useSendErrorsContext;
